import {createBrowserRouter, createRoutesFromElements, Route} from "react-router-dom";
import ActiveTrip from "./pages/ActiveTrip";
import NextStop from "./pages/NextStop";
import React from "react";
import RoutePage from "./pages/Route";
import Settings from "./pages/Settings";
import Address from "./pages/Address";
import ConfirmDeliveryForm from "./pages/ConfirmDeliveryForm";

export default createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route id="tab-trip:index" path="/:tripKey" element={<ActiveTrip/>}/>
            <Route id="tab-trip:address" path="address/:tripKey/:taskGuid" element={<Address/>}/>
            <Route id="tab-trip:confirm-delivery" path="confirm-delivery-form/:tripKey/:taskId" element={<ConfirmDeliveryForm/>}/>
            <Route id="tab-route:index" path="route/:tripKey" element={<RoutePage/>}/>
            <Route id="tab-next-stop:index" path="next-stop/:tripKey" element={<NextStop/>}/>
            <Route id="tab-settings:index" path="settings/:tripKey" element={<Settings/>}/>
        </Route>
    )
);